import React, { Component, Context, ContextType, FC } from 'react';

import styled from 'styled-components';
import { LegacyContext } from '~/stormpath/components/LegacyContextType';
import { AuthContext } from '~/stormpath/components/Router';

import { Box, BoxProps, Checkbox } from '@mui/material';

import { BEDBANK_PROPERTY_STATUSES_ENUM } from '~/consts/bedbank';

import { isAdmin } from '~/utils/adminPermission';

interface Props {
  id: string;
  value: string;
  onStatusUpdate: (value) => boolean;
}

interface State {
  isAdmin: boolean;
  statuses: Array<{
    name: string;
    value: boolean;
  }>;
}

const CheckboxWrapper = styled((props: BoxProps) => <Box component="div" {...props} />)`
  text-align: left;
  font-size: 14px;
` as FC<BoxProps>;

class CheckboxGroup extends Component<Props, State> {
  timer: NodeJS.Timeout;
  static contextType: Context<LegacyContext> = AuthContext;
  context: ContextType<typeof AuthContext>;

  constructor(props, context) {
    super(props);
    this.state = {
      isAdmin: isAdmin(context.user),
      statuses: BEDBANK_PROPERTY_STATUSES_ENUM.map((name) => {
        return {
          name,
          value: name === props.value,
        };
      }),
    };
  }

  changeStatusValue = (e) => {
    const elementName = e.target.name;

    this.setState(
      {
        statuses: BEDBANK_PROPERTY_STATUSES_ENUM.map((name) => {
          return {
            name,
            value: name === elementName,
          };
        }),
      },
      () => {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          this.props.onStatusUpdate(elementName);
        }, 1000);
      },
    );
  };

  render() {
    return (
      <>
        {this.state.statuses.map(({ name, value }) => {
          return (
            <CheckboxWrapper key={`${this.props.id}-status-${name}`}>
              <Checkbox
                id={`${this.props.id}-status-${name}`}
                disabled={!this.state.isAdmin}
                checked={value}
                name={name}
                onClick={(event) => event.stopPropagation()}
                onChange={this.changeStatusValue}
                size="small"
                sx={{ padding: 0 }}
              />
              <label htmlFor={`${this.props.id}-status-${name}`}>&nbsp; {name}</label>
            </CheckboxWrapper>
          );
        })}
      </>
    );
  }
}

export default CheckboxGroup;
